export default __webpack_public_path__ + "static/media/1.01c1b0d6.jpg";